import React from 'react'
import logoGov from '../images/logoGov.png';
import logoCo from '../images/logoCo.png';

const FootBar = () => {
    return (
        <>
            <nav className="flex items-center bg-govNavBar p-5 h-8">
                <a className='px-3'href='https://www.colombia.co//' target="_blank">
                    <img className='h-7' src={logoCo} alt="Logo Colombia"/>
                </a>
                <a href='https://www.gov.co/' target="_blank">
                    <img className='h-7' src={logoGov} alt="Logo Governacion"/>
                </a>
            </nav>
            
        </>
    );
}
 
export default FootBar;